module.exports = __webpack_public_path__ + "static/media/fake-news-great.ec732d0a.mp3";